<template>
  <div class="pa-section-panel-sub-title">
    <div class="pa-icon-title">
      <div class="pa-icon" :class="iconClass">
        <slot name="icon"></slot>
      </div>
      <div class="pa-text">
        <slot name="title">{{title}}</slot>
      </div>
    </div>

    <div class="pa-caption-bar">
      <slot name="caption">{{caption}}</slot>
    </div>
  </div>
</template>

<script>
export default {
  props : {
    title: {
      default: null
    },
    caption: {
      default: null
    },

    iconClass : {
      default: function(){
        return [];
      }
    }
  }
}
</script>

<style lang="scss">
@import "~bulma/sass/utilities/_all";

.pa-section-panel-sub-title{
  user-select: none;

  .pa-icon-title{
    margin:0 0 .1rem;
    padding:.2rem 0 .1rem;

    display: flex;
    align-items: center;
    justify-content: center;

    .pa-icon{
      width:1.4rem;
      height:inherit;
      margin-right:.2rem;

      svg{
        margin-top:6px;
      }

      &-clip{
        width:.95rem;
      }
    }

    .pa-text{
      color:#7F4F16;
      font-size: 1.1rem;
      text-align: center;

      @media screen and (min-width: $desktop) {
        font-size:1.4rem;
      }
    }
  }

  .pa-caption-bar{
    background-color:#7F4F16;
    color:#D2BA9E;
    font-size: .8rem;
    border-radius: 8px;
    text-align: center;
    margin:0 auto;
    width:98%;
    user-select: none;

    @media screen and (min-width: $desktop) {
      font-size:1rem;
    }
  }
}
</style>